export default __webpack_public_path__ + "static/media/City_of_Code_GitHub.5a87fd75.jpeg";